import { Button } from "@mui/material";
import { ColorsConstants } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const ButtonTwo = ({
  onClick,
  title,
  children,
  startIcon = null,
  endIcon = null,
  sx,
  ...props
}) => {
  return (
    <Button
      variant="outlined"
      size="medium"
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        ...typography.bodyLarge,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: ColorsConstants.primaryPurple60,
        },
        borderRadius: "8px",
        height: 40,
        borderColor: ColorsConstants.primaryBlue100,
        color: ColorsConstants.primaryBlue100,
        textTransform: "none",
        fontWeight: 600,
        ...sx, // 👈 allow overrides
      }}
      {...props}
    >
      {children ?? title}
    </Button>
  );
};

export default ButtonTwo;